import { rem } from "polished";
import styled from "styled-components";

export const StyledSponsorCard = styled.a`
  margin: 0 ${rem(12)} ${rem(24)} ${rem(12)};
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: ${rem(10)} ${rem(20)};
  text-decoration: none;
`;

export const StyledSponsorCardLogo = styled.img`
  object-fit: scale-down;
  max-width: 100%;
`;

export const StyledSponsorCardText = styled.span`
  text-align: center;
  font-weight: 600;
  font-size: ${rem(16)};
  line-height: ${rem(32)};
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: #000;
  margin-top: ${rem(10)};
  max-width: 100%;
`;
